import React from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import Login from "./pages/Authentication/Login/Login";
import Home from "./pages/Home/Home";
import Navbar from "./components/navbar/Navbar";
import UploadFiles from "./pages/UploadFiles/UploadFiles";
import Gallery from "./pages/Gallery/Gallery";
import MyGallery from "./pages/MyGallery/MyGallery";
import AdminGallery from "./pages/Admin/AdminGallery/AdminGallery";
import AllEvents from "./pages/Events/AllSubEvents/AllSubEvents";
import AdminLandingPage from "./pages/Admin/AdminLandingPage/AdminLandingPage";
import Developers from "./pages/DevelopersPage/Developers";

function App() {
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Navbar /> <Home />
            </>
          }
        />
        <Route path="login" element={<Login />} />
        {/* <Route path="uploadfiles" element={<><Navbar /><UploadFiles /></>} /> */}
        <Route
          path="gallery"
          element={
            <>
              <Navbar />
              <Gallery />
            </>
          }
        />
        <Route
          path="events"
          element={
            <>
              <Navbar />
              <AllEvents />
            </>
          }
        />
        <Route
          path="mygallery"
          element={
            <>
              <Navbar />
              <MyGallery />
            </>
          }
        />
        <Route
          path="admingallery"
          element={
            <>
              <Navbar />
              <AdminGallery />
            </>
          }
        />
        <Route
          path="adminpanel"
          element={
            <>
              <Navbar />
              <AdminLandingPage />
            </>
          }
        />
        <Route
          path="developers"
          element={
            <>
              <Developers />
            </>
          }
        ></Route>
      </Routes>
    </>
  );
}

export default App;
